import type { PointerEvent } from "react";

import classes from "./editor.module.css";

/** The timeline's height when the editor opens (live's 260 px panel and its gap). */
export const TIMELINE_HEIGHT = 268;
/** Live's limits for its timeline panel (`editor.tsx`'s vertical `Resizable`). */
export const MIN_TIMELINE_HEIGHT = 200;
export const MAX_TIMELINE_HEIGHT = 500;

function within(height: number): number {
  return Math.min(MAX_TIMELINE_HEIGHT, Math.max(MIN_TIMELINE_HEIGHT, Math.round(height)));
}

/**
 * Live's handle on the timeline's top edge (`resizable-panel.tsx`, issue 828): dragged up, the
 * timeline grows, down it shrinks, from 200 to 500 px; the preview takes the rest. As live's, the
 * height is the page's only, and, as the clips' trim handles, the handle is the pointer's alone.
 */
export function TimelineResizer({ height, onHeight }: { height: number; onHeight: (height: number) => void }) {
  const drag = (event: PointerEvent<HTMLDivElement>) => {
    if (event.button !== 0) return;
    event.preventDefault();
    const startY = event.clientY;
    const move = (moved: MouseEvent) => onHeight(within(height + startY - moved.clientY));
    const stop = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", stop);
      window.removeEventListener("pointercancel", stop);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", stop);
    window.addEventListener("pointercancel", stop);
  };
  return (
    <div
      data-timeline-resizer
      aria-hidden
      className={classes.timelineResizer}
      onPointerDown={drag}
    />
  );
}
